import { PENDING, FULFILLED, REJECTED } from "redux-promise-middleware";
import {
  FETCH_PERMISSIONS,
  FETCH_PERMISSION,
  CREATE_PERMISSION,
  UPDATE_PERMISSION,
  DELETE_PERMISSION
} from "../actions/permission";

const SINGLE_DATA_INITIAL_STATE = {
  data: {},
  error: null,
  loading: false
};
const MULTI_DATA_INITIAL_STATE = {
  data: [],
  error: null,
  loading: false
};

export function permissions(state = MULTI_DATA_INITIAL_STATE, { type, payload }) {
  switch (type) {
    case `${FETCH_PERMISSIONS}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${FETCH_PERMISSIONS}_${FULFILLED}`:
      return Object.assign({}, state, payload.data, {
        loading: false,
        error: null
      });
    case `${FETCH_PERMISSIONS}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}

export function permission(state = SINGLE_DATA_INITIAL_STATE, { type, payload }) {
  switch (type) {
    case `${FETCH_PERMISSION}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${FETCH_PERMISSION}_${FULFILLED}`:
      return Object.assign({}, state, { data: payload.data }, { loading: false, error: null });
    case `${FETCH_PERMISSION}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}

export function createPermission(state = SINGLE_DATA_INITIAL_STATE, { type, payload }) {
  switch (type) {
    case `${CREATE_PERMISSION}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${CREATE_PERMISSION}_${FULFILLED}`:
      return Object.assign({}, state, { data: payload.data }, { loading: false, error: null });
    case `${CREATE_PERMISSION}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}

export function updatePermission(state = SINGLE_DATA_INITIAL_STATE, { type, payload }) {
  switch (type) {
    case `${UPDATE_PERMISSION}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${UPDATE_PERMISSION}_${FULFILLED}`:
      return Object.assign({}, state, { data: payload.data }, { loading: false, error: null });
    case `${UPDATE_PERMISSION}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}

export function deletePermission(state = SINGLE_DATA_INITIAL_STATE, { type, payload }) {
  switch (type) {
    case `${DELETE_PERMISSION}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${DELETE_PERMISSION}_${FULFILLED}`:
      return Object.assign({}, state, { data: payload.data }, { loading: false, error: null });
    case `${DELETE_PERMISSION}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/permission.js